import React from "react";
import { useTranslation } from "react-i18next";
import { EC } from "../../utils/const/ecommerce-colors-const";
import {
    formatProductPrice,
    getPriceLocale,
    getProductPricing,
} from "../../utils/ecommerce/product-pricing";

export default function ProductPriceDisplay({ product, size = "md", className = "" }) {
    const { t, i18n } = useTranslation();
    const pricing = getProductPricing(product);
    const locale = getPriceLocale(i18n.language);

    const saleClass = size === "lg" ? EC.price.textLg : EC.price.textXl;
    const originalClass = size === "lg" ? "text-lg text-slate-400 line-through" : "text-sm text-slate-400 line-through";

    return (
        <div className={className}>
            {pricing.isOnSale ? (
                <>
                    <div className="flex flex-wrap items-center gap-2">
                        <p className={saleClass}>{formatProductPrice(pricing.salePrice, pricing.abreviatura, locale)}</p>
                        <span className="rounded-full bg-ct-price-500 px-2.5 py-0.5 text-xs font-bold uppercase tracking-wide text-white">
                            {t("ct_discount_off", { percent: pricing.porcentajeDescuento })}
                        </span>
                    </div>
                    <p className={`mt-1 ${originalClass}`}>
                        {t("ct_price_was")}{" "}
                        {formatProductPrice(pricing.precioOriginal, pricing.abreviatura, locale)}
                    </p>
                </>
            ) : (
                <p className={saleClass}>{formatProductPrice(pricing.salePrice, pricing.abreviatura, locale)}</p>
            )}
        </div>
    );
}

export function ProductDiscountBadge({ product, className = "" }) {
    const { t } = useTranslation();
    const pricing = getProductPricing(product);

    if (!pricing.isOnSale) return null;

    return (
        <span
            className={`absolute right-3 top-3 rounded-full bg-ct-price-500 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-white shadow-md ${className}`}
        >
            {t("ct_discount_off", { percent: pricing.porcentajeDescuento })}
        </span>
    );
}
